import { MyPortfolioContainer } from '@/features/sparklend/my-portfolio/MyPortfolioContainer'

export function MyPortfolioPage() {
  return <MyPortfolioContainer />
}
